import { HostBinding, Component } from '@angular/core';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { environment } from '../../../environments/environment';
import { LOGIN_CONTEXTO } from 'app/config';

@Component({
  selector: 'app-acompanhamento',
  templateUrl: './acompanhamento.component.html',
  styleUrls: ['./acompanhamento.component.scss'],
  animations: [routerTransition],
})
export class AcompanhamentoComponent {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  public opcoesLogin = {
    tipoLogin: 'GLOBAL',
    siglaSistema: 'VEST',
    contexto: LOGIN_CONTEXTO,
  };
}
